module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-approval-item"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.iconName,
      "size": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rt-approval-item-middle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea5d2fb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/approval/rtApprovalItem.vue
// module id = 1473
// module chunks = 116